import React from "react";

import Label from "@busbud/design-system-components/dist/Label";

import { useAppContext } from "@app/helpers/hooks";
import { optionsDisplay } from "@app/helpers/options-display";
import type { TripOption, TripOptionsMatrix } from "@app/types/results-types";
import type { SearchInfo } from "@app/types/search-types";

interface Props {
  search: SearchInfo;
  selected_trip: TripOption;
  trip_options_matrix: TripOptionsMatrix;
}

export const PassengerAndClassInformation: React.FC<Props> = ({
  search,
  selected_trip,
  trip_options_matrix
}) => {
  const { translator } = useAppContext();

  const selected_trip_information = optionsDisplay(
    translator,
    search,
    selected_trip,
    trip_options_matrix
  );

  return (
    <Label
      size="xs"
      fontWeight="bold"
      whiteSpace="nowrap"
      color="text.tertiary.opaque"
    >
      {selected_trip_information}
    </Label>
  );
};
